module.exports = {
  navLinks: [
    {
      name: 'Home',
      url: '/'
    },
    {
      name: 'Sobre',
      url: '/about'
    },
    {
      name: 'Jogos',
      url: '/games'
    },
    {
      name: 'Conquistas',
      url: '/achievements'
    },
    {
      name: 'Venda',
      url: '/sale'
    },
  ]
};
